// Single source of truth mapping Settings/configure tab titles <-> URL-hash slugs,
// so each configure page is addressable / shareable via /app/settings#<slug>
// (e.g. #team, #knowledge-base). Used by Settings/index.js and the app-shell
// ConfigureMenu so the menu, deep-links, and the rendered tab stay in sync.

export const TAB_TO_SLUG = {
  Integrations: "tools",
  "API Access": "api-access",
  "Knowledge Base": "knowledge-base",
  "Data Interpreter": "data-interpreter",
  Webhooks: "webhooks",
  Guardrails: "guardrails",
  Team: "team",
  Wallet: "wallet",
  Billing: "billing",
  Profile: "profile",
  Pricing: "plans",
};

export const SLUG_TO_TAB = Object.fromEntries(
  Object.entries(TAB_TO_SLUG).map(([tab, slug]) => [slug, tab])
);

/** Tab title -> "#slug" (empty string for unknown tabs). */
export const tabToHash = (tab) =>
  TAB_TO_SLUG[tab] ? `#${TAB_TO_SLUG[tab]}` : "";

/** "#slug" (or "slug") -> tab title, or null if unknown. */
export const hashToTab = (hash) =>
  SLUG_TO_TAB[(hash || "").replace(/^#/, "")] || null;
